import { useState } from 'react';
import { videos, siteConfig } from '@/mocks/data';
import VideoModal from '@/components/feature/VideoModal';

export default function VideoGallerySection() {
  const [activeVideo, setActiveVideo] = useState<(typeof videos)[0] | null>(null);

  const getWhatsappHref = () =>
    `https://wa.me/${siteConfig.whatsappNumber}?text=${encodeURIComponent('Merhaba, sitenizdeki Fineco Isı Pompası tanıtım videosunu izledim. Detaylı bilgi ve fiyat almak istiyorum.')}`;

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-900 mb-4">
            Tanıtım Videolarımızı İzleyin
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            Fineco Isı Pompası ve Atak Sistem Enerji hizmetleri hakkında hazırladığımız kısa tanıtımları izleyebilir, detaylı bilgi için doğrudan WhatsApp üzerinden bize ulaşabilirsiniz.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {videos.map((video) => (
            <div
              key={video.id}
              className="bg-background-100 rounded-lg overflow-hidden border border-background-200/70 group"
            >
              <div className="relative overflow-hidden cursor-pointer" onClick={() => setActiveVideo(video)}>
                <img
                  src={video.thumbnail}
                  alt={video.title}
                  className="w-full aspect-video object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/30 flex items-center justify-center group-hover:bg-black/40 transition-colors">
                  <div className="w-14 h-14 rounded-full bg-primary-500 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-background-50 text-2xl w-6 h-6 flex items-center justify-center ml-0.5"></i>
                  </div>
                </div>
              </div>

              <div className="p-5">
                <h3 className="font-heading text-base text-foreground-900 mb-2">{video.title}</h3>
                <p className="text-foreground-600 text-sm leading-relaxed mb-4">{video.description}</p>
                <div className="flex flex-col sm:flex-row gap-2">
                  <button
                    onClick={() => setActiveVideo(video)}
                    className="flex items-center justify-center gap-1.5 bg-secondary-500 text-background-50 px-4 py-2 rounded-md text-xs font-medium hover:bg-secondary-600 transition-colors whitespace-nowrap"
                  >
                    <i className="ri-play-circle-line w-4 h-4 flex items-center justify-center"></i>
                    Tanıtımı İzle
                  </button>
                  <a
                    href={getWhatsappHref()}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center gap-1.5 bg-[#25D366] text-white px-4 py-2 rounded-md text-xs font-medium hover:bg-[#1faa51] transition-colors whitespace-nowrap"
                  >
                    <i className="ri-whatsapp-line w-4 h-4 flex items-center justify-center"></i>
                    WhatsApp'tan Bilgi Al
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {activeVideo && (
        <VideoModal
          isOpen={!!activeVideo}
          onClose={() => setActiveVideo(null)}
          instagramLink={activeVideo.instagramLink}
          title={activeVideo.title}
        />
      )}
    </section>
  );
}